import { ValidationValueMessage } from "react-hook-form/dist/types/validator";

const EMAIL_REGEX =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const URL_REGEX =
  /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g;

export const EMAIL_VALIDATION: ValidationValueMessage<RegExp> = {
  message: "This email address is invalid.",
  value: EMAIL_REGEX,
};

export const getMaxLengthRule = (length: number) => {
  return {
    message: `The maximum number of characters allowed is ${length}`,
    value: length,
  };
};

export const required = (v: string | undefined) => {
  if (!v) return false;
  if (v.trim().length > 0) return true;
  return "This field is required.";
};

export const url = (v: string | undefined) => {
  if (!v) return true;
  if (v.match(URL_REGEX)) return true;
  return "Please enter a valid URL.";
};

export const emailIsValid = (email: string | undefined) => {
  if (email && EMAIL_REGEX.test(email)) return true;
  return "Please enter a valid email address.";
};
